import yup from 'src/libraries/validator.library';

export const EmailPayloadSchema = yup
.object({
  errorEmails: yup.array().of(yup.string()),
  errorMessage: yup.string(),
  reqMessage: yup.string(),
  reqStatus: yup.boolean(),
  statusCode: yup.number(),
  successfulEmails: yup.array().of(yup.string()),
})
.defined();

export const EmailBodySchema = yup
.object({
  toEmailIds: yup.array().of(yup.string().defined()).defined().required(),
  from: yup.string().defined().required(),
  subjectLine: yup.string().defined().required(),
  coverLetter: yup.string().defined(),
  eMailBody: yup.string().defined(),
  attachments: yup.array().of(yup.string()).optional(),
})
.defined();

export type IEmailFormat = yup.InferType<typeof EmailBodySchema>;
